import React, { FC, MouseEventHandler } from 'react';

interface EditButtonProps {
  className: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export const EditButton: FC<EditButtonProps> = ({ className, onClick }) => {
  return (
    <button onClick={onClick} className={`btn btn-primary btn-sm ${className}`} type="button">
      <span className="fa fa-edit"></span>
    </button>
  );
};